import ServiceOfTheMonth from './ServiceOfTheMonth';

export default ServiceOfTheMonth;
